import { render, staticRenderFns } from "./TraineeTalksTopics.vue?vue&type=template&id=e4fe0a92&"
import script from "./TraineeTalksTopics.vue?vue&type=script&lang=js&"
export * from "./TraineeTalksTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports